class PlaceableTooltip {
	constructor(node) {
		this._node = node;
		this._shown = false;
		
		this.documentMousePos = {x:0,y:0};
		node.addEventListener('click', this.hide.bind(this));
		this.hide();
	} 

	hide() {
		
		this._shown = true;
		this._node.classList.add("hidden");
	}

	show() {
		this._shown = false;
		this._node.classList.remove("hidden");
	}

	place(x, y) {
		var arrowNode = this._node.querySelector('[ control-role=arrow_box]');
		if (x > this._node.parentNode.clientWidth / 2) {
			x = x - this._node.clientWidth;
			x = x - 40;
			arrowNode.classList.remove('arrow_box_left');
			arrowNode.classList.add('arrow_box');
			
		}else{
			x = x + 40;
			arrowNode.classList.add('arrow_box_left');
			arrowNode.classList.remove('arrow_box');
		}

		if (y > this._node.parentNode.clientHeight / 2) {
			//y = y - this._node.clientHeight;
		}

		
		y = y-(this._node.clientHeight / 2);
		this._node.style.top = y + "px";
		this._node.style.left = x + "px";

	}

	set toolTipLabels(val) {
		var toolTipRows = this._node.querySelectorAll(`[tooltip-row]`);
		for (var i = 0; i < toolTipRows.length; i++) {
			let toolTipRow = toolTipRows[i];
			let rowIndex = toolTipRow.getAttribute('tooltip-row');
			if (val[rowIndex]) {
				let label = toolTipRow.querySelector(`[tooltip-label]`);
				if (label) {
					label.innerHTML = val[rowIndex];
				}

			} else {
				toolTipRow.classList.add('hidden');
			}

		}




	}
}

export default PlaceableTooltip;